export default __webpack_public_path__ + "static/auvelity-and-me-logo-d901ea894df40f0f4dd633f83ecc2849.svg";